import {
  Button,
  Col,
  DatePicker,
  Input,
  Layout,
  Pagination,
  Popover,
  Row,
  Select,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";

import { FaPlus } from "react-icons/fa";
import { IoSearchSharp } from "react-icons/io5";
import { useNavigate } from "react-router";
import Card from "../../components/card";

import { FaFilter, FaSearch } from "react-icons/fa";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Get } from "../../config/api/get";
import { COMMUNITY } from "../../config/constants/api";
import "./community.css";

export default function Community() {
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const [allPost, setAllPost] = useState([]);
  const [open, setOpen] = useState(false);

  function search() {
    alert(value);
  }


  // pagindation
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 14,
    totalDocs: 0,
    totalPages: 0,
  });

  const getPosts = async (pageNumber, pageSize, search, reset = false) => {
    try {
      const response = await Get(COMMUNITY.getAllPost, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        type: reset ? "" : filter.type || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });

      setLoading(false);

      if (response.status === true) {
        setAllPost(response?.data);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        // swal("Error", "Something went wrong", "error")
        console.log("error====>", response);
      }
    } catch (error) {
      setLoading(false);
      swal("Error", error?.message || "something went wrong", "error");
      console.log(error);
    }
  };

  useEffect(() => {
    getPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getPosts(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };

  const handleTypeChange = (value) => {
    setFilter({
      ...filter,
      type: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getPosts(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="community-pagination-custom-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="community-pagination-custom-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const filterContent = (
    <div className="filterDropdown community-filter-popover">
      <div>
        <p className="mainLabel" style={{ padding: "10px" }}>
          Filter
        </p>
      </div>
      <hr style={{ margin: 0 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">Lesson Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          placeholder="From"
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          placeholder="To"
        />

        <p className="mainLabel">Lesson Type:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Lesson Type"
          value={filter.type}
          onChange={(e) => handleTypeChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "TUTORING", label: "Training" },
            { value: "COACHING", label: "Consulting" },
          ]}
        />

        <p className="mainLabel">Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "UPCOMING", label: "Upcoming" },
          ]}
        />

        <Button
          type="primary"
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="loginButton"
          onClick={() => {
            getPosts();
          }}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout className="community-page" style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground communitybnr community-banner relative"
      >
        <div className="community-banner-overlay" />
        <div className="community-banner-orb" />
        <div className="community-banner-content-wrap">
          <div className="community-banner-content">
          <Typography.Title
            className="fontFamily1 tranerbnr-content community-banner-title"
            level={1}
          >
            Find your community
          </Typography.Title>
          <Typography.Text
            className="fontFamily1 community-banner-subtitle"
          >
            From education, learning, there's a place for you.
          </Typography.Text>

          <div className="community-banner-search-wrap">
            <input
              type="text"
              placeholder="Explore Discussion"
              className="community-banner-search-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  search();
                }
              }}
            />

            <IoSearchSharp
              onClick={search}
              size={20}
              className="community-banner-search-icon"
            />
          </div>
        </div>
        </div>
      </Row>

      <Row className="community-toolbar" justify="center">
        <Col xs={24} xl={22} lg={23}>
          <div className="community-toolbar-inner">
            <Popover
              content={filterContent}
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
              placement="bottomRight"
              arrow={false}
            >
              <Button shape="circle" type="primary" className="community-filter-btn">
                <FaFilter style={{ fontSize: "16px", color: "white" }} />
              </Button>
            </Popover>
            <Input
              className="mainInput dashInput community-search-input"
              placeholder="Search Here"
              onChange={(e) => handleSearch(e.target.value)}
              suffix={
                <FaSearch
                  style={{
                    color: "#64748b",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    getPosts(1, paginationConfig.limit, filter.keyword)
                  }
                />
              }
              onPressEnter={() =>
                getPosts(1, paginationConfig.limit, filter.keyword)
              }
            />
          </div>
        </Col>
      </Row>

      <Row className="md:mx-20 grid-Container community-grid">
        {loading ? (
          <div className="community-loading">
            <p className="text-3xl font-semibold" style={{ margin: 0 }}>
              Loading
            </p>
            <div className="community-loading-spinner" aria-hidden="true" />
          </div>
        ) : (
          <>
            <article
              className="community-post-card community-post-card--add"
              onClick={() => navigate("/create-form")}
            >
              <div className="community-add-card-inner">
                <div className="community-add-card-icon">
                  <FaPlus size={28} color="#fff" />
                </div>
                <h3 className="community-add-card-title">Add New</h3>
                <p className="community-add-card-subtitle">
                  Start a new post and connect with your community.
                </p>
              </div>
            </article>

            {allPost?.docs?.map((post, i) => (
              <Card post={post} key={i} />
            ))}
          </>
        )}
      </Row>

      <Row className="community-pagination-bar" justify="center">
        <Col xs={24} xl={22} lg={23}>
          <div className="community-pagination-inner">
            <p className="fontFamily1 community-pagination-meta">{message}</p>
            <Pagination
              className="styledPagination community-pagination"
              showSizeChanger={false}
              onChange={(page) => handlePageChange(page)}
              current={parseInt(paginationConfig.pageNumber, 10)}
              pageSize={paginationConfig.limit}
              total={paginationConfig.totalDocs}
              itemRender={itemRender}
            />
          </div>
        </Col>
      </Row>
    </Layout>
  );
}
